import { from, Observable, of } from 'rxjs'
import { catchError, defaultIfEmpty, filter, map, mergeMap, switchMap, take } from 'rxjs/operators'
import { OrganizationService } from './organization.service'
import { SiteMembershipService } from './site-membership.service'

export const OPEN_REGISTRATION_FEATURE_TOGGLE_KEY = 'open_registration'
const OPEN_REGISTRATION_FEATURE_TOGGLE_CONCURRENCY = 4

export function hasOpenRegistrationEnabled(
  organizationService: OrganizationService,
  siteMembershipService: SiteMembershipService
): Observable<boolean> {
  return siteMembershipService.mine().pipe(
    map((siteMemberships) => [
      ...new Set(siteMemberships.map((siteMembership) => siteMembership.organization_id)),
    ]),
    switchMap((organizationIds) => {
      if (!organizationIds.length) return of(false)

      return from(organizationIds).pipe(
        mergeMap(
          (organizationId) => organizationService.hasFeatureToggleEnabled(
            organizationId.toString(),
            OPEN_REGISTRATION_FEATURE_TOGGLE_KEY
          ).pipe(
            catchError(() => of(false))
          ),
          OPEN_REGISTRATION_FEATURE_TOGGLE_CONCURRENCY
        ),
        filter((result) => result === true),
        take(1),
        defaultIfEmpty(false),
      )
    }),
    catchError(() => of(false))
  )
}
